<div *ngIf="displayError">

  <div class="text-danger">
    <i class="fa fas fa-exclamation-triangle" aria-hidden="true"></i> {{ errorMsg }}
  </div>

</div>